<template>
  <div id="app">
    <calendar/>
  </div>
</template>

<script>
import calendar from './components/calendar'

export default {
  name: 'app',
  components: {
    calendar
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue